const createRipple = (button, xPosition, yPosition, isKeyboard = false) => {
  const bounds = button.getBoundingClientRect();
  const xRelative = xPosition - bounds.left;
  const yRelative = yPosition - bounds.top;
  const newRipple = document.createElement("span");
  const diameter = Math.max(button == null ? void 0 : button.clientWidth, button.clientHeight);
  const radius = diameter / 2;
  newRipple.style.width = newRipple.style.height = `${diameter}px`;
  newRipple.style.left = isKeyboard ? `${xPosition - radius}px` : `${xRelative - radius}px`;
  newRipple.style.top = isKeyboard ? `${yPosition - radius}px` : `${yRelative - radius}px`;
  newRipple.classList.add("ripple");
  const oldRipple = button.getElementsByClassName("ripple")[0];
  if (oldRipple) {
    oldRipple.remove();
  }
  button.appendChild(newRipple);
  newRipple.addEventListener("animationend", () => {
    newRipple.remove();
  });
  newRipple.addEventListener("animationcancel", () => {
    newRipple.remove();
  });
};
const handleRippleKeyboard = (event) => {
  const button = event.currentTarget;
  if (!button.hasAttribute("disabled") && button.getAttribute("aria-disabled") !== "true" && event.key === "Enter") {
    const centerWidth = button.clientWidth / 2;
    const centerHeight = button.clientHeight / 2;
    createRipple(button, centerWidth, centerHeight, true);
  }
};
const handleRippleMouse = (event) => {
  const button = event.currentTarget;
  if (!button.hasAttribute("disabled") && button.getAttribute("aria-disabled") !== "true") {
    const xPosition = event.clientX;
    const yPosition = event.clientY;
    createRipple(button, xPosition, yPosition, false);
  }
};
export {
  createRipple,
  handleRippleKeyboard,
  handleRippleMouse
};
//# sourceMappingURL=animations.js.map
